// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"79d21c82","347":"f769cbf9","651":"ecbb426f"}[chunkId] + ".chunk.js";
};